/* sb-dc-logopads.js - make the whole logo clickable, not just its ink.
   2026-09-12 (v2).

   Reported: "some logos click, some don't, and it feels random", and then,
   after v1: "these still select one layer at a time."

   WHY: these logos are stroke-only vector paths. The canvas hit test answers
   on the drawn line and nowhere else, so the empty middle of a circle is not
   the object, and a thin outline is missed most of the time.

   WHAT THIS DOES: lays an invisible pad over each multi-shape logo, in the
   DOM, above the canvas. Clicking anywhere on the logo - ink or not - offers
   the whole logo to sb-dc-logoswap.js.

   IT IS NOT A LAYER. Nothing is added to the design, so the print file, the
   proof and the price are untouched.

   ⚠ v2 - THE GATE IS GONE, AND THE CLICK IS PASSED THROUGH
   v1 kept the pads inert until it could confirm the inches-to-pixels mapping,
   by checking that the app's selection control (.obj-cluster) landed inside
   the matching pad. That check can never pass: measured on the board, that
   control is drawn in the MIDDLE OF THE CANVAS, not on the selected object.
   So the pads stayed locked and nothing changed - which is what the store was
   still seeing.
     v2 drops the gate and makes the pads harmless instead: a pad click is
   FORWARDED to whatever is underneath it, so the canvas still receives the
   click exactly as before. If the mapping were ever wrong, the worst case is
   the editor behaving as it does today, not clicks disappearing.

   The mapping itself: the board is drawn "contain" inside .konvajs-content and
   centred, so scale = min(stageW/boardW, stageH/boardH). Measured 5.25 px/in
   on an 8ft board in an 828x504 stage, which is 504/96 exactly.

   Diagnostics: window.__dcLogoPads() */
(function () {
  'use strict';

  var TICK = 500, GAP_IN = 0.5;

  var info = { pads: 0, scale: 0, picks: 0, forwarded: 0, why: '' };
  window.__dcLogoPads = function () { return info; };

  function api() {
    var a = window.__dcApi;
    return (a && a.front && Array.isArray(a.front.layers) && a.spec) ? a : null;
  }

  function box(l) { return { x: +l.xIn || 0, y: +l.yIn || 0, w: +l.widthIn || 0, h: +l.heightIn || 0 }; }
  function near(A, B) {
    return !(A.x > B.x + B.w + GAP_IN || A.x + A.w + GAP_IN < B.x ||
             A.y > B.y + B.h + GAP_IN || A.y + A.h + GAP_IN < B.y);
  }

  function groups(a) {
    var S = (a.doc || a.front).layers.filter(function (l) { return l.type === 'shape' && !l.locked; });
    var used = {}, out = [];
    S.forEach(function (s, i) {
      if (used[i]) return;
      var g = [i]; used[i] = 1;
      var grew = true;
      while (grew) {
        grew = false;
        S.forEach(function (t, j) {
          if (used[j]) return;
          var B = box(t);
          for (var k = 0; k < g.length; k++) {
            if (near(box(S[g[k]]), B)) { used[j] = 1; g.push(j); grew = true; return; }
          }
        });
      }
      if (g.length > 1) out.push(g.map(function (k) { return S[k]; }));
    });
    return out;
  }

  function bboxOf(g) {
    var x0 = 1e9, y0 = 1e9, x1 = -1e9, y1 = -1e9;
    g.forEach(function (l) {
      var b = box(l);
      x0 = Math.min(x0, b.x); y0 = Math.min(y0, b.y);
      x1 = Math.max(x1, b.x + b.w); y1 = Math.max(y1, b.y + b.h);
    });
    return { x: x0, y: y0, w: x1 - x0, h: y1 - y0 };
  }

  function mapper(a) {
    if (window.SBDC914?.legacy) return window.SBDC914.legacy.mapper(a);
    var stage = document.querySelector('.konvajs-content');
    if (!stage) return null;
    var r = stage.getBoundingClientRect();
    var bw = +a.spec.widthIn || 0, bh = +a.spec.heightIn || 0;
    if (!bw || !bh || r.width < 20) return null;
    var s = Math.min(r.width / bw, r.height / bh);
    info.scale = +s.toFixed(3);
    return { ox: r.left + (r.width - bw * s) / 2, oy: r.top + (r.height - bh * s) / 2, s: s };
  }

  /* let the canvas have the same click, so the pads can only ever add */
  function forward(ev, pad, group) {
    if (window.SBDC914?.legacy) { window.SBDC914.legacy.forward(ev, pad, group); info.forwarded++; }
  }

  var wrap = null, pads = [];

  function clear() {
    if (wrap && wrap.parentNode) wrap.parentNode.removeChild(wrap);
    wrap = null; pads = [];
    info.pads = 0;
  }

  function build(a) {
    var m = mapper(a);
    if (!m) return;
    var gs = groups(a);
    clear();

    wrap = document.createElement('div');
    wrap.id = 'sbdc-logopads';
    wrap.style.cssText = 'position:fixed;left:0;top:0;width:0;height:0;z-index:54;';
    document.body.appendChild(wrap);

    gs.forEach(function (g) {
      var b = bboxOf(g);
      var el = document.createElement('div');
      el.style.cssText = [
        'position:fixed',
        'left:' + Math.round(m.ox + b.x * m.s) + 'px',
        'top:' + Math.round(m.oy + b.y * m.s) + 'px',
        'width:' + Math.round(b.w * m.s) + 'px',
        'height:' + Math.round(b.h * m.s) + 'px',
        'background:transparent', 'pointer-events:none'
      ].join(';');
      wrap.appendChild(el);   // no listener on the pad - the document click below does the pick
      pads.push({ g: g, el: el });
    });
    info.pads = pads.length;
  }

  var down = null;   // where the press started - a click that ends a drag (move/resize/rotate) is not a pick
  document.addEventListener('pointerdown', function (ev) { down = { x: ev.clientX, y: ev.clientY, t: ev.target }; }, true);
  document.addEventListener('click', function (ev) {
    var d = down; down = null;
    if (!d || d.t !== ev.target || !(ev.target instanceof Element) || !ev.target.closest('.konvajs-content')) return;   // canvas only
    if (Math.abs(ev.clientX - d.x) > 4 || Math.abs(ev.clientY - d.y) > 4) return;   // the end of a drag, not a click
    for (var i = 0; i < pads.length; i++) {
      var r = pads[i].el.getBoundingClientRect();
      if (ev.clientX >= r.left && ev.clientX <= r.right && ev.clientY >= r.top && ev.clientY <= r.bottom) {
        info.picks++;
        if (window.__dcLogoSwapPick) window.__dcLogoSwapPick(pads[i].g);
        forward(ev, pads[i].el, pads[i].g);
        return;
      }
    }
  }, true);
  var sig = '';
  setInterval(function () {
    var a = api();
    if (!a) return;
    if (window.SBDC914?.legacy.managed()) { clear(); sig = ''; return; }
    var gs = groups(a);
    var stage = document.querySelector('.konvajs-content');
    var r = stage ? stage.getBoundingClientRect() : null;
    var s = gs.length + '|' + (r ? Math.round(r.width) + 'x' + Math.round(r.height) + ',' + Math.round(r.left) + ',' + Math.round(r.top) : '') +
            '|' + a.spec.widthIn + 'x' + a.spec.heightIn + '|' + JSON.stringify([window.__dcGeom?.scale, window.__dcGeom?.ox, window.__dcGeom?.oy, gs.map(g=>g.map(l=>[l.id,l.xIn,l.yIn,l.widthIn,l.heightIn,l.rotation,l.visible,l.locked]))]);
    if (s !== sig) { sig = s; build(a); }
  }, TICK);

  window.addEventListener('resize', function () { sig = ''; });
  window.addEventListener('scroll', function () { sig = ''; }, true);
})();
